import { ApolloLink, from } from '@apollo/client';
import { BatchHttpLink } from '@apollo/client/link/batch-http';
import fetch from 'cross-fetch';
import { onError } from '@apollo/client/link/error';
import { token as getToken, login } from '../../shared/services/authService';
import logger from '../../shared/services/logger';
import config from './config';

const { serviceGraphqlRoot, urlRoot } = config;

const link = ({ token = '' } = {}) => {
  const authentication = new ApolloLink((operation, forward) => {
    if (getToken() || token) {
      operation.setContext({
        headers: {
          authorization: `bearer ${getToken() || token}`,
        },
      });
    }
    return forward(operation);
  });

  const batchLink = new BatchHttpLink({
    uri: ({ operationName }) => {
      if (operationName && operationName.includes('localsearch')) {
        return `${urlRoot}/graphql`;
      }
      return serviceGraphqlRoot;
    },
    fetch,
    batchMax: 1,
  });

  const authError = onError(err => {
    const { graphQLErrors } = err;

    if (graphQLErrors) {
      for (let index = 0; index < graphQLErrors.length; index += 1) {
        const {
          extensions: { exception },
        } = graphQLErrors[index];
        const error = exception || {};
        const { status } = error;
        if ([401, 403].includes(status)) {
          login({
            redirectUrl: window.location.pathname,
          });
          break;
        }
        if (status === 400) {
          logger.warn(error);
        } else {
          logger.error(error);
        }
      }
    }
  });

  return from([authError, authentication, batchLink]);
};

export default link;
